import { render } from "./ReturnInventoryDistribution.vue?vue&type=template&id=13840e4c"
import script from "./ReturnInventoryDistribution.vue?vue&type=script&lang=js"
export * from "./ReturnInventoryDistribution.vue?vue&type=script&lang=js"

import "./ReturnInventoryDistribution.vue?vue&type=style&index=0&id=13840e4c&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__